import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import css from './FavoritesPage.module.css';
import { H3, LayoutSingleColumn, ListingCard, Page, PaginationLinks } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import { connect, useSelector } from 'react-redux';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { getListingsById } from '../../ducks/marketplaceData.duck';
import { compose } from 'redux';
import { cardRenderSizes, isArrayLength } from '../../util/genericHelpers';

const FavoritesPage = ({ listings, pagination, queryParams, children }) => {
  const intl = useIntl();
  const title = intl.formatMessage({ id: 'FavoritesPage.title' });
  const scrollingDisabled = useSelector(isScrollingDisabled);
  const hasPaginationInfo = !!pagination && pagination.totalItems != null;

  const getCardComponent = listing => (
    <ListingCard
      className={css.listingCard}
      key={listing.id.uuid}
      listing={listing}
      renderSizes={cardRenderSizes(false)}
      isFavoritesPage={true}
    />
  );
  // return <IconRipple />;
  const page = queryParams ? queryParams.page : 1;
  const paginationLinks =
    listings?.length > 50 ? (
      <PaginationLinks
        className={css.pagination}
        pageName="FavoritesPage"
        pageSearchParams={{ page }}
        pagination={pagination}
      />
    ) : null;
  return (
    <Page className={css.root} title={title} scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>
        <div className={css.fixWidthContainer}>
          <H3 as="h1" className={css.title}>
            <FormattedMessage
              id={isArrayLength(listings) ? 'FavoritesPage.heading' : 'FavoritesPage.noFavorites'}
            />
          </H3>
          <div className={css.listingCards}>
            {isArrayLength(listings) ? listings.map(listing => getCardComponent(listing)) : null}
          </div>
          {paginationLinks}
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  const {
    queryParams,
    currentPageResultIds,
    pagination,
    fetchListingInProgress,
    fetchListingError,
    removeItemFromFavoritesInProgress,
  } = state.FavoritesPage;
  const listings = getListingsById(state, currentPageResultIds);
  return {
    queryParams,
    listings,
    pagination,
    fetchListingInProgress,
    fetchListingError,
    removeItemFromFavoritesInProgress,
  };
};

export default compose(connect(mapStateToProps))(FavoritesPage);
